module.exports = __webpack_public_path__ + "img/wuliu.06300f4f.png";